module.exports = __webpack_public_path__ + "00070f2a82dc56f7cdf637d079db638c.png";